import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const reviews = [{
  text: 'Mein 7-Jähriger hat seinen ersten Roboter in 20 Minuten gebaut und seitdem nicht mehr nach dem Tablet gefragt. Das beste Geld, das ich je als Elternteil ausgegeben habe.',
  name: 'Jessica M.',
  meta: 'Mutter von 2 · Texas, USA',
  letter: 'J',
  color: 'bg-brand'
}, {
  text: 'Ich war anfangs skeptisch — „noch ein digitales Produkt“ — aber die Anleitungen sind so klar, dass sogar ich ihnen folgen konnte. Meine Tochter ist begeistert.',
  name: 'Sarah K.',
  meta: 'Mutter von 3 · London, UK',
  letter: 'S',
  color: 'bg-emerald-500'
}, {
  text: 'Wir machen jetzt jeden Samstagmorgen ein Projekt. Mein Sohn nennt es „Robotertag“. Er hat in 2 Monaten mehr über Technik gelernt als in einem ganzen Schuljahr.',
  name: 'Michael R.',
  meta: 'Vater von 1 · Sydney, AU',
  letter: 'M',
  color: 'bg-blue-500'
}, {
  text: 'Der Fortschritts-Tracker als Bonus war eine geniale Idee. Meine Kinder wetteifern darum, wer mehr Projekte fertigstellt. Die Bildschirm-Streits sind so gut wie verschwunden.',
  name: 'Rachel T.',
  meta: 'Mutter von 4 · Toronto, CA',
  letter: 'R',
  color: 'bg-amber-500'
}, {
  text: 'Freitagabend heruntergeladen, den Schnellstart-Guide gedruckt und vor dem Schlafengehen hatten wir einen funktionierenden Roboter. Mein 5-Jähriger war so stolz. Absolut jeden Cent wert.',
  name: 'Laura B.',
  meta: 'Mutter von 2 · Madrid, ES',
  letter: 'L',
  color: 'bg-purple-500'
}];
function Stars() {
  return <div className="flex text-amber-400" aria-hidden="true" data-id="element-178">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-179" />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-180">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-181">
        <SectionHeading eyebrow="Was Eltern sagen" title={<>Echte Familien. Echte Ergebnisse.</>} subtitle="Über 2.000 Familien haben MakerLab bereits genutzt, um ihre Kinder vom Bildschirm wegzubringen und etwas Echtes zu bauen. Das sagen sie." data-id="element-182" />

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-183">
          <Stars data-id="element-184" />
          <p className="text-sm font-semibold text-ink" data-id="element-185">
            2.000+ Familien — Durchschnitt 4,9 von 5
          </p>
        </div>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6" data-id="element-186">
          {reviews.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className="break-inside-avoid rounded-3xl border border-ink/10 bg-cream p-6" data-id="element-187">
              <Stars data-id="element-188" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-189">
                „{r.text}“
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-190">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold text-white ${r.color}`} data-id="element-191">
                  {r.letter}
                </span>
                <span data-id="element-192">
                  <span className="block text-sm font-bold text-ink" data-id="element-193">
                    {r.name}
                  </span>
                  <span className="block text-xs text-ink/50" data-id="element-194">{r.meta}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}